<template>
    <div class="public-personal-center">
        <div class="left-menu">
            <a-menu
                style="width: 239px"
                mode="inline"
                :theme="theme"
                @click="handleClick"
                :open-keys.sync="openKeys"
            >
                <a-sub-menu v-for="item in menuList" :key='item.key'>
                    <span slot="title"><i style="margin-right:7px;" class="iconfont" :class="item.icon"></i><span>{{item.title}}</span></span>
                    <a-menu-item v-for="item1 in  item.children" :id="item1.title" :key='item1.moduleId' :title='item1.title'>
                        <div>{{item1.title}}</div>
                    </a-menu-item>
                </a-sub-menu>
            </a-menu>
        </div>
        <div class="right-content">
            <div class="content-detail">
                <div class="content-head">
                    <div class="content-title">{{currentTitle}}</div>
                    <div class="content-condition">
                        <a-select @change="changeDataRange" v-model="dataRange" placeholder='请选择' style="width: 132px;margin-top:4px;margin-left:4px;">
                            <a-select-option value="4">
                                全部
                            </a-select-option>
                            <a-select-option value="1">
                                我负责的
                            </a-select-option>
                            <a-select-option value="2">
                                我创建的
                            </a-select-option>
                            <a-select-option value="3">
                                我协同的
                            </a-select-option>
                            <a-select-option value="" disabled>
                                我的下级
                            </a-select-option>
                            <a-select-option v-for="item in subordinateList" :value="item.value" :key="item.key">
                                &nbsp;&nbsp;{{item.title}}
                            </a-select-option>
                        </a-select>
                        <a-divider type="vertical" />
                        <div style="display:inline-block;position:relative;">
                            <a-icon type="search" style="position:absolute;left:5px;top:13px;z-index:10" />
                            <a-input v-model="dataTitle" @keyup.enter="inputQueryData" style="padding-left:25px;border:none;width:300px;height:38px;" placeholder="搜索标题（按Enter键搜索）" />
                        </div>
                        <div style="display:inline-block;float:right;padding-top:6px;position:relative;">
                            <a-button v-if="hasAddAuthority" @click="addOperation" type="primary" icon="plus" style="height:26px;margin-right:8px">
                                新增
                            </a-button>
                            <LabelManagement v-if="hasLabelAuthority"></LabelManagement>
                            <a-divider type="vertical" style="margin:0 16px" />
                            <a-icon @click="orderOperation" :class="{'active':orderActive}" class="order-icon" type="api" />
                            <ScreenColumn ref="child3"></ScreenColumn>
                            <div class="order-box" v-if="orderActive" @click="orderPrevent">
                                <div class="orderby">排序</div>
                                <div class="order-list">
                                    <div class="order-item" @click="changeSortField(index,item.id)" v-for="(item,index) in sortFieldListData" :key='index'>
                                        <span>{{item.name}}</span>
                                        <a-icon v-if="item.sortMode=='asc'" type="arrow-up" />
                                        <a-icon v-if="item.sortMode=='desc'" type="arrow-down" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-body">
                    <div class="content-table">
                        <a-table :scroll="{ x: 'max-content'}" :columns="tableHeader" :data-source="tableData.records" :pagination='false' :rowKey="(record,index)=>{return index}">
                            <div v-for="(item1,index1) in tableHeader" :key='index1'  :slot="item1.dataIndex" slot-scope="text" v-html="text"></div>
                        </a-table>
                        
                        <div style="margin-top:16px;">
                            <div style="display:inline-block;float:left" v-if="moneyFieldList.length!=0">
                                <span style="color:rgba(80, 80, 80, 1);font-size:14px;margin-left:10px;">汇总计算</span>
                                <a-select style="width: 120px;margin-left:10px;border:1px solid rgba(158, 172, 196, 0.3)" placeholder='请选择' @change="changeFieldList" v-model="summaryCalculation">
                                    <a-select-option :value="item.value" v-for="(item,index) in moneyFieldList" :key='index'>
                                        {{item.name}}
                                    </a-select-option>
                                </a-select>
                                <span v-if="ifShowTotal" style="color:rgba(80, 80, 80, 1);font-size:14px;margin-left:10px;">总计：</span>
                                <span v-if="ifShowTotal" style="color:rgba(80, 80, 80, 1);font-size:14px">{{totalData}}</span>
                            </div>
                            <a-pagination
                                style="float:right"
                                v-model="currentPage"
                                :page-size-options="pageSizeOptions"
                                :total="total"
                                show-size-changer
                                :page-size="pageSize"
                                @change="pageChange"
                                @showSizeChange="onShowSizeChange"
                            >
                                <template slot="buildOptionText" slot-scope="props">
                                    <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
                                </template>
                            </a-pagination>
                            <div style="float:right;margin:4px 16px 0 0">
                                总条数：{{total}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ListDetails ref="listDetails" @queryBasicData='queryBasicData'></ListDetails>
        
        <a-modal :centered='true' :maskClosable='false' v-model.trim="addNewDataModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>确认新增</span>
                    <a-icon @click="cancelAddNewData" type="close" />
                </div>
                <div class="add-data">
                    <a-input v-model="transactionName" placeholder="请输入名称" />
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelAddNewData">取消</a-button>
                        <a-button type="primary" @click="sureAddNewData">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
    import ScreenColumn from '../../components/ScreenColumn'
    import ListDetails from '../../components/ListDetails'
    import LabelManagement from '../../components/LabelManagement'
    export default {
        name: 'Account',
        components: { ScreenColumn, ListDetails, LabelManagement },
        data() {
            return {
                theme: 'light',
                basicInfo: '',
                menuList: [],
                moduleId: '',
                tableData: '',
                tableHeader: [],
                pageSizeOptions: ['10', '50 ','100', '200', '500', '1000'],
                currentPage: 1,
                pageSize: 10,
                total: 0,
                orderActive: false,
                screenActive: false,
                currentUserProvider: 'user',
                userObjBool: {},
                selectedCreateTime: '',
                selectedEditTime: '',
                selectedEditTimeBool: false,
                currentHelper: 'user',
                dataTitle: '',
                dataRange: undefined,
                sortFieldListData: [],
                sortFieldObj: {
                    sortField: '',
                    sortMode: ''
                },
                selectedConditionList: [],
                countFlag: false,
                hasAddAuthority: false,
                addNewDataModal: false,
                dataId: '',
                boolList: [],
                replyCommentId: '',
                helperValueList: [],
                currentFieldId: '',
                attachmentList: [],
                attachmentId: '',
                newFormData2: '',
                filterTagName: '',
                tagListData: [],
                currentTagId: '',
                moneyFieldList: [],
                ifShowTotal: false,
                totalData: 0,
                passModuleId: '',
                openKeys: [],
                currentTitle: '',
                transactionName: '',
                hasLabelAuthority: false,
                summaryCalculation: undefined,
                subordinateList: [],

            }
        },
        methods: {
            handleClick(e) {
                this.currentTitle = e.domEvent.target.innerHTML
                this.moduleId = e.key
                if(this.currentTitle != '客户账号'){
                    document.getElementById("客户账号").setAttribute("class","ant-menu-item")
                }
                this.summaryCalculation = undefined
                this.totalData = 0
                this.ifShowTotal = false
                this.dataTitle = ''
                this.dataRange = undefined
                this.currentPage = 1
                this.pageSize = 10
                this.sortFieldObj.sortField = ''
                this.sortFieldObj.sortMode = ''
                this.querySortFieldList()
                this.queryConditionListData()
                this.selectedConditionList = []
                this.queryBasicData()
                this.queryIfHasAddAuthority()
                this.queryTagList()
                this.querySummaryCalculation()
                this.queryIfHasLabelManageAuthority()
            },
            initMenuClick() {
                this.currentTitle = this.menuList[0]['children'][0]['title']
                this.moduleId = this.menuList[0]['children'][0]['moduleId']
                setTimeout(()=>{
                    document.getElementById("客户账号").setAttribute("class","ant-menu-item ant-menu-item-selected")
                },200)
                this.querySortFieldList()
                this.queryConditionListData()
                this.queryBasicData()
                this.queryIfHasAddAuthority()
                this.queryTagList()
                this.querySummaryCalculation()
                this.queryIfHasLabelManageAuthority()
            },
            changeDataRange(value) {
                this.dataRange = value
                this.currentPage = 1
                this.pageSize = 10
                this.queryBasicData()
            },
            inputQueryData() {
                this.currentPage = 1
                this.pageSize = 10
                this.queryBasicData()
            },
            queryBasicData() {
                this.axios.post('/api/module/data/list', {
                    current: this.currentPage,
                    size: this.pageSize,
                    moduleId: this.moduleId,
                    labelId: this.currentTagId,
                    dataRange: this.dataRange==undefined?'':this.dataRange,
                    dataTitle: this.dataTitle,
                    screeningConditionList: this.selectedConditionList,
                    sortField: this.sortFieldObj.sortField,
                    sortMode: this.sortFieldObj.sortMode,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.total = response.data.data.tableData.total
                        this.tableData = response.data.data.tableData
                        this.tableHeader = response.data.data.tableHeader
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            onShowSizeChange(current, pageSize) {
                this.pageSize = pageSize;
                this.currentPage = current
                this.queryBasicData()
            },
            pageChange(current, pageSize) {
                this.currentPage = current
                this.pageSize = pageSize
                this.queryBasicData()
            },
            orderPrevent() {
                event.stopPropagation();
            },
            orderOperation() {
                event.stopPropagation();
                this.screenActive = false
                this.orderActive = !this.orderActive
            },
            cancelSet() {
                this.screenActive = false
            },
            sureSet() {
                this.screenActive = false
            },
            setScreenCondition() {
                event.stopPropagation();
                this.orderActive = false
                this.screenActive = !this.screenActive
            },
            screenPrevent() {
                event.stopPropagation();
            },
            selectUserProvider(data) {
                this.currentUserProvider = data
            },
            selectUser(id) { 
                for(let item in this.userObjBool){
                    if(id == item){
                        this.userObjBool[id] = true
                    }else{
                        this.userObjBool[item] = false
                    }
                }
                this.$forceUpdate();
            },

            calcelPersonBox() {
                event.stopPropagation();
            },
            querySortFieldList() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/module/sortFieldList', 
                        params: {
                            moduleId: this.moduleId
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        let arr = response.data.data
                        let brr = [], obj = {}
                        for(let i = 0; i < arr.length; i++){
                            obj = {}
                            obj.id = arr[i]['id']
                            obj.name = arr[i]['name']
                            obj.sortMode = ''
                            brr.push(obj)
                        }
                        this.sortFieldListData = brr
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            changeSortField(index, id) {
                if(this.sortFieldListData[index]['sortMode'] == 'asc'){
                    for(let i = 0; i < this.sortFieldListData.length; i++){
                        this.sortFieldListData[i]['sortMode'] = ''
                    }
                    this.sortFieldListData[index]['sortMode'] = 'desc'
                    this.sortFieldObj.sortMode = 'desc'
                }else{
                    for(let i = 0; i < this.sortFieldListData.length; i++){
                        this.sortFieldListData[i]['sortMode'] = ''
                    }
                    this.sortFieldListData[index]['sortMode'] = 'asc'
                    this.sortFieldObj.sortMode = 'asc'
                }
                this.sortFieldObj.sortField = id
                this.queryBasicData()
            },
            queryConditionListData() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/module/screeningConditionList', 
                        params: {
                            moduleId: this.moduleId
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        console.log("数据显示")
                        console.log(response.data.data)
                        this.$refs.child3.getData(this.moduleId,response.data.data)
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryScreenColumnData() {
                this.selectedConditionList = this.$refs.child3.conditionList
            },
            viewDetailsData(id) {
                this.countFlag = true
                this.$refs.listDetails.getPassModuleId(this.passModuleId)
                this.$refs.listDetails.changeAffairBoolValue()
                this.$refs.listDetails.getDataIdValue(id)
                this.$refs.listDetails.queryDetailsData()
                this.$refs.listDetails.queryTabList()
                this.$refs.listDetails.setCurrentTab()
                this.$refs.listDetails.queryUserList()
            },
            childCarryViewDetails(moduleId, dataId) {
                this.countFlag = true
                this.$refs.listDetails.getPassModuleId(moduleId)
                this.$refs.listDetails.changeAffairBoolValue()
                this.$refs.listDetails.getDataIdValue(dataId)
                this.$refs.listDetails.queryDetailsData()
                this.$refs.listDetails.queryTabList()
                this.$refs.listDetails.setCurrentTab()
                this.$refs.listDetails.queryUserList()
            },
            queryIfHasAddAuthority() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/module/hasAddAuthority', 
                        params: {
                            moduleId: this.moduleId
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.hasAddAuthority = response.data.data.hasAddAuthority
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            addOperation() {
                this.addNewDataModal = true
            },
            cancelAddNewData() {
                this.addNewDataModal = false
            },
            sureAddNewData() {
                this.addNewDataModal = false
                this.axios.post('/api/module/data/add', {
                    moduleId: this.moduleId,
                    name: this.transactionName
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('新增成功')
                        this.transactionName = ''
                        this.queryBasicData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            queryTagList() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/label/list', 
                        params: {
                            moduleId: this.moduleId,
                            name: this.filterTagName,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.tagListData = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            selectCurrentTag(id) {
                this.currentTagId = id
                this.queryBasicData()
            },
            querySummaryCalculation() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/module/moneyFieldList', 
                        params: {
                            moduleId: this.moduleId,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.moneyFieldList = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            changeFieldList(value) {
                this.ifShowTotal = true
                this.axios.post('/api/module/totalMoney', {
                    moduleId: this.moduleId,
                    fieldId: value,
                    labelId: this.currentTagId,
                    dataRange: this.dataRange,
                    dataTitle: this.dataTitle,
                    screeningConditionList: this.selectedConditionList,
                    sortField: this.sortFieldObj.sortField,
                    sortMode: this.sortFieldObj.sortMode,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.totalData = response.data.data.total
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            queryIfHasLabelManageAuthority() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/module/hasLabelAuthority', 
                        params: {
                            moduleId: this.moduleId,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.hasLabelAuthority = response.data.data.hasLabelAuthority
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            querySubordinate() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/serviceProviderUser/subordinateList', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.subordinateList = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
        },
        mounted: function() {
            this.menuList = JSON.parse(this.$route.query.params)
            this.querySubordinate()
            this.initMenuClick()
            for(let i = 0; i < this.menuList.length; i++){
                this.openKeys.push(this.menuList[i]['key'])
            }
            if(sessionStorage.getItem('menuKey')){
                this.current = sessionStorage.getItem('menuKey')
            }
            document.onclick = (e)=> {
                if(e.target.className == 'affair-title'){
                    if(e.target.attributes.moduleid.value!=''){
                        this.passModuleId = e.target.attributes.moduleid.value
                    }else{
                        this.passModuleId = this.moduleId
                    }
                    this.viewDetailsData(e.target.attributes['1']['nodeValue'])
                }
                this.orderActive = false
                
                if(this.countFlag){
                    setTimeout(()=>{
                        this.$refs.listDetails.changePersonBoxBoolValue()
                        this.$refs.listDetails.changeTagsBoolValue()
                    },200)
                }

                // if(e.target.className == 'comment-img'){
                //     console.log(e.target)
                //     console.log(e.target.src)
                //     this.imgModal = true
                //     this.imgUrl = e.target.src
                // }
                this.$forceUpdate();
            }
        },
    }
</script>

<style scoped lang="less">
    .public-personal-center{
        display: flex;
        width: 100%;
        height: 100%;
        background: rgba(240, 242, 243, 1);
        .left-menu{
            width: 240px;
            height: 100%;
            background: #fff;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
            z-index: 999;
        }
        .right-content{
            flex: 1;
            height: 100%;
            .content-detail{
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                background: rgba(240, 242, 243, 1);
                position: relative;
                overflow: hidden;
                .content-head{
                    height: 88px;
                    background: #fff;
                    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
                    z-index: 10;
                    .content-title{
                        height: 50px;
                        border-bottom: 1px solid rgba(229, 229, 229, 1);
                        line-height: 50px;
                        color: rgba(18, 18, 18, 1);
                        font-size: 14px;
                        font-weight: bold;
                        padding-left: 15px;
                    }
                    .content-condition{
                        height: 38px;
                        i.order-icon{
                            margin-right: 20px;
                            cursor: pointer;
                            font-size: 16px;
                        }
                        i.active{
                            color: rgba(58, 220, 255, 1);
                        }
                        .order-box{
                            position: absolute;
                            right: 62px;
                            top: 36px;
                            width: 240px;
                            height: 312px;
                            box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.12);
                            background: #fff;
                            z-index: 10;
                            display: flex;
                            flex-direction: column;
                            .orderby{
                                height: 44px;
                                padding-left: 20px;
                                line-height: 44px;
                                color: rgba(158, 172, 196, 1);
                                font-size: 13px;
                            }
                            .order-list{
                                flex: 1;
                                overflow-y: auto;
                                .order-item{
                                    height: 44px;
                                    line-height: 44px;
                                    padding: 0 12px 0 20px;
                                    font-size: 13px;
                                    color: rgba(18, 18, 18, 1);
                                    cursor: pointer;
                                    i{
                                        float: right;
                                        margin-top: 14px;
                                        color: rgba(158, 172, 196, 1);
                                    }
                                }
                                .order-item:hover{
                                    background: rgba(240, 242, 243, 0.5);
                                }
                            }
                            
                        }
                        .screen-box{
                            height: 588px;
                            width: 720px;
                            box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.12);
                            z-index: 20;
                            background: #fff;
                            position: absolute;
                            right: 23px;
                            top: 36px;
                            display: flex;
                            flex-direction: column;
                        }
                    }
                }
                .content-body{
                    flex: 1;
                    padding: 104px 24px 18px 16px;
                    position: absolute;
                    top: 0px;
                    width: 100%;
                    left: 0px;
                    overflow: hidden;
                    height: 100%;
                    .content-table{
                        background: #fff;
                        width: 100%;
                        height: 100%;
                        overflow: auto;
                        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
                        padding: 18px 20px 48px 20px;
                    }
                }
            }
        }
    }
        .add-new-data-modal{
        .add-title{
            padding: 20px 20px 14px 24px;
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .add-data{
            border-top: 1px solid rgba(229, 229, 229, 1);
            padding: 16px 24px 24px 24px;
            i{
                color: rgba(255, 170, 0, 1);
                font-size: 20px;
                margin-right: 20px;
            }
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 16px;
            }
        }
        .btn-group{
            padding: 0 20px 20px 0;
            height: 48px;
            div{
                float: right;
            }
            button{
                display: inline-block;
                width: 64px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
    }
</style>